import { KEY_CONFIG } from './../../config/key-config';
import {
  Component, Input, Output, EventEmitter, OnInit, ViewEncapsulation, ElementRef
} from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { ConfirmModalPopupModel } from './confirm-modal-popup.model';
import {UtilityService} from './../../providers';
declare var initAriaHidden: any;
declare var removeAriaHidden: any;



@Component({
  selector: 'app-confirm-modal',
  styleUrls: ['./confirm-modal-popup.component.scss'],
  templateUrl: './confirm-modal-popup.component.html',
  encapsulation: ViewEncapsulation.None
})

export class ConfirmModalPopupComponent implements OnInit {

  @Input()
  modalPopupObject: ConfirmModalPopupModel;
  @Input() triggerElement: any;

  @Output()
  modalOutput: EventEmitter<boolean>;

  focusabbleElements: any;

  ngOnInit() {
    document.body.classList.add('modal-open');
    initAriaHidden();
  }

  constructor(private el: ElementRef, private utilityService: UtilityService) {
    this.modalOutput = new EventEmitter<boolean>();
  }

  btnAction(value) {
    document.body.classList.remove('modal-open');
    removeAriaHidden();
    this.modalOutput.emit(value);
    this.focusabbleElements = undefined;
    if (this.triggerElement) {
      this.triggerElement.focus();
    }
  }

  loadFocustelements() {
    if (!this.focusabbleElements) {
      const focusableEls =  this.utilityService.getFocusableElements(this.el);
     this.focusabbleElements = Array.prototype.slice.call(focusableEls);
     // this.focusabbleElements[0].focus();
     document.getElementById('modalHeading').focus();
    }
  }

  handleKeydown(event) {
    if (event.keyCode === KEY_CONFIG.escapeKey) {
      this.btnAction(false);
      return;
    }
    this.utilityService.handleKeyPress(event, this.focusabbleElements);
  }
}
